import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";

const queryKey = (id: string) => ["movie-content", id];

const useMovieContentQuery = (
  id: string,
  options?: {
    isEnabled?: boolean;
  },
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(id),
    queryFn: () => api.getMovieContent(id),
    enabled: options?.isEnabled,
  });
};

export default useMovieContentQuery;
